<template>
  <div v-loading="loading">
    <no-store
      v-if="!hasStore && !loading"
      @refresh="getStoreDetail"
    />
    <div
      v-if="hasStore && !loading"
      class="store"
    >
      <el-card>
        <img
          src="~@/assets/store.png"
          style="margin-left: -10px;"
        >
        <span class="f24 fb">{{ storeInfo.storeName }}</span>
        <span class="gray tel">{{ tel }}</span>
        <div
          class="float-right btn m-t-10"
          type="text"
          @click="toSet"
        >
          设置<i class="el-icon-arrow-right" />
        </div>
        <div class="desc">
          简介：{{ storeInfo.storeDesc || '暂无' }}
        </div>
      </el-card>
      <el-row
        :gutter="20"
        class="m-t-20"
      >
        <el-col :span="12">
          <el-card>
            <div class="classify-title">
              经营状况
            </div>
            <ve-histogram
              height="330px"
              :data="chartData"
              :settings="chartSettings"
              :title="chartOptions.title"
              :legend="chartOptions.legend"
              :extend="chartExtend"
            />
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <div class="store-info">
              <div>
                店铺收入总计
                <span class="income p-l-40">{{ businessInfo.totalAmount | thousandMark }}</span>
              </div>
              <h4 class="fb m-t-40">
                订单数
              </h4>
              <el-row class="m-t-20">
                <el-col :span="8">
                  成交订单
                  <span>{{ businessInfo.orderSuccessNum }}</span>
                </el-col>
                <el-col :span="8">
                  待支付订单
                  <span>{{ businessInfo.orderGoingNum }}</span>
                </el-col>
                <el-col :span="8">
                  关闭订单
                  <span>{{ businessInfo.orderFailNum }}</span>
                </el-col>
              </el-row>
              <el-row class="m-t-40">
                <el-col :span="12">
                  <h4 class="fb m-t-10">
                    今日成交
                  </h4>
                  <div class="m-t-20 m-b-10">
                    成交金额
                    <span>{{ businessInfo.orderSuccessAmountToday | thousandMark }}</span>
                  </div>
                  <div>
                    成交订单
                    <span>{{ businessInfo.orderSuccessNumToday }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <h4 class="fb m-t-10">
                    意向单
                  </h4>
                  <div class="m-t-20 m-b-10">
                    意向单金额
                    <span>{{ businessInfo.orderGoingAmountToday | thousandMark }}</span>
                  </div>
                  <div>
                    意向单订单
                    <span>{{ businessInfo.orderGoingNum }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-card class="m-t-20">
        <div class="classify-title">
          待确认意向单
        </div>
        <div
          v-for="item in unconfimedOrderList"
          :key="item.id"
          class="order f14"
        >
          {{ item.tag==='S'? item.reserveUserName + ' 摘牌' : item.tenderUserName + ' 挂牌' }}
          {{ item.attrList.find(item=>item.attrCode==='brand') ? item.attrList.find(item=>item.attrCode==='brand').v : '' }}
          {{ item.varietyName }} {{ item.quantity }} {{ item.unitName }}，
          <template v-if="!!item.unitPrice">
            生成总价为
            <span class="orange">{{ Number(item.unitPrice) * Number(item.quantity) | thousandMark  }}</span>
            的意向单
          </template>
          <template v-else>
            价格待定
          </template>

          <div
            class="float-right btn"
            type="text"
            @click="toConfirm(item)"
          >
            去确认<i class="el-icon-arrow-right" />
          </div>
        </div>
      </el-card>
      <el-card class="m-t-20">
        <div class="classify-title">
          今日挂牌
        </div>

        <today-trade type="today-trade" />
      </el-card>

      <open-store
        v-if="openStoreVisible"
        :opt-type="'set'"
        :store-info="storeInfo"
        :open-store-visible="openStoreVisible"
        @close="openStoreVisible=false"
        @refresh="getStoreDetail"
      />
    </div>
    <confirm-order
      v-if="isConfirm"
      :is-show="isConfirm"
      :opt-type="'edit'"
      :detail-data="detailData"
      @close="isConfirm=false"
    />
  </div>
</template>

<script>
import VeHistogram from 'v-charts/lib/histogram'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import Vue from 'vue'
import api from '@/api'
import OpenStore from './components/open-store'
import NoStore from './components/no-store'
import TodayTrade from '../trade'
import ConfirmOrder from '../order/components/confirm-order'
Vue.component(VeHistogram.name, VeHistogram)
export default {
  name: 'StoreHome',
  components: {
    OpenStore,
    NoStore,
    TodayTrade,
    ConfirmOrder
  },
  data () {
    return {
      unconfimedOrderList: [],
      hasStore: false,
      tel: '',
      isConfirm: false,
      loading: true,
      storeInfo: {},
      quatationList: [],
      openStoreVisible: false,
      chartExtend: {
        series: {
          barWidth: 25,
        }
      },
      chartSettings: {
        labelMap: {
          startDate: '日期',
          totalAmount: '总金额',
          totalBrowse: '总浏览量',
        },
        showLine: ['总浏览量'],
        itemStyle: {
          color: '#ffc600', // 柱状的颜色
        }
      },
      chartOptions: {
        // title: {
        //   text: '经营概况',
        //   x: 'left',
        // },
        // 图例
        legend: {
          x: 'right',
          y: 'top',
          show: false
        },
      },
      chartData: {
        columns: ['startDate', 'totalAmount'],
        rows: [],
      },
      businessInfo: {}
    }
  },
  created () {
    this.getStoreDetail()
    this.getOrderList()
  },
  methods: {
    getBusinessInfo () {
      const param = {
        'space': null, // 多少天的数据被合并为一个统计值，默认为1，每天一条统计记录
        'countNum': null, // 需要统计条数，默认为7，汇总天数 = countNum * space
        'endDate': null, // 统计截止日期（不包含截止日期当天数据），为空则默认到今天截止
      }
      api.myStore.getBusinessInfo(param).then(res => {
        this.businessInfo = res.data || {}
        this.chartData.rows = res.data.histograms || []
      })
    },
    // 判断是否已开店
    getStoreDetail () {
      api.myStore.getStoreDetail().then(res => {
        this.storeInfo = res.data || {}
        if (res.data.storeName) {
          this.hasStore = true
          this.getContact()
          this.getBusinessInfo()
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 联系人方式
    getContact () {
      api.myStore.getContact(this.storeInfo.userId).then(res => {
        const contactList = res.data || []
        this.tel = contactList.length ? contactList[0].content : ''
      })
    },
    // 设置店铺
    toSet () {
      this.openStoreVisible = true
    },
    // 确认意向单
    async toConfirm (item) {
      this.detailData = await this.getDetail(item)
      this.isConfirm = true
    },
    // 意向单详情
    async getDetail (row) {
      const res = await api.myStore.getOrderDetail(row.id)
      return res.data
    },
    // 待确认意向单
    async getOrderList () {
      const param = {
        currentNo: '1',
        pageSize: '999999',
        userAccount: this.$store.state.user.info.account,
        reserveType: 'RESERVE'
      }
      let res = await api.myStore.getOrderData(param)
      this.unconfimedOrderList = res.data.rows
    },

  },
}
</script>

<style lang="scss">
.store {
  .store-info {
    height: 286px;
  }
  .income {
    font-size: 32px;
    color: #ff5f00;
  }
  .orange {
    color: #ff5f00;

  }
  .order {
    border: 1px solid #f2f2f2;
    padding: 10px;
    margin-top: 10px;
  }
  .btn {
    color:#3b88fd;
    cursor: pointer;
    font-size: 14px;
  }
  .tel {
    padding-left: 16px;
    color: #666666;

  }
  .desc {
    color: #999999;
    word-break: break-all;
    line-height: 30px;
  }
  canvas {
    margin-top: -40px!important;
  }
  .ve-histogram {
    margin-bottom: -80px!important;
  }
}

</style>
